import { useState } from 'react';

const CORRECT_PASSWORD = 'mawari2025';

interface PasswordGateProps {
  onUnlock: () => void;
}

export default function PasswordGate({ onUnlock }: PasswordGateProps) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const [shake, setShake] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === CORRECT_PASSWORD) {
      sessionStorage.setItem('site_unlocked', 'true');
      onUnlock();
    } else {
      setError(true);
      setShake(true);
      setTimeout(() => setShake(false), 500);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white relative overflow-hidden">
      {/* 背景装飾 */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -left-40 w-96 h-96 bg-pink-100/60 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-40 -right-40 w-96 h-96 bg-rose-100/60 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-pink-50/80 rounded-full blur-3xl"></div>
      </div>

      <div
        className={`relative z-10 w-full max-w-md mx-4 transition-all duration-300 ${shake ? 'animate-shake' : ''}`}
      >
        {/* ロゴ */}
        <div className="flex justify-center mb-10">
          <img
            src="https://static.readdy.ai/image/019c42ef209c92acff15d1e580b417d6/19f5ffb7ee66b02c49330cb25beab366.png"
            alt="Mawari FREAK"
            className="h-16 w-auto object-contain"
          />
        </div>

        {/* カード */}
        <div className="bg-white border border-gray-200 rounded-2xl p-10 shadow-xl">
          <div className="text-center mb-8">
            <div className="w-14 h-14 flex items-center justify-center mx-auto mb-4 bg-pink-50 rounded-full border border-pink-200">
              <i className="ri-lock-line text-2xl text-pink-500"></i>
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">アクセス制限中</h1>
            <p className="text-gray-500 text-sm leading-relaxed">
              このサイトは現在非公開です。<br />
              パスワードを入力してアクセスしてください。
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                パスワード
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setError(false);
                }}
                placeholder="パスワードを入力"
                className={`w-full px-4 py-3 rounded-lg bg-gray-50 border text-gray-900 placeholder-gray-400 text-sm focus:outline-none focus:ring-2 transition-all ${
                  error
                    ? 'border-red-400 focus:ring-red-300/50'
                    : 'border-gray-200 focus:ring-pink-300/50 focus:border-pink-400'
                }`}
                autoFocus
              />
              {error && (
                <p className="mt-2 text-sm text-red-500 flex items-center gap-1">
                  <i className="ri-error-warning-line"></i>
                  パスワードが正しくありません
                </p>
              )}
            </div>

            <button
              type="submit"
              className="w-full py-3 bg-gradient-to-r from-pink-500 to-rose-500 text-white font-bold rounded-lg hover:shadow-lg hover:shadow-pink-300/40 transition-all cursor-pointer whitespace-nowrap text-sm"
            >
              アクセスする
            </button>
          </form>
        </div>

        <p className="text-center text-gray-400 text-xs mt-6">
          © 2025 Mawari FREAK. All rights reserved.
        </p>
      </div>

      <style>{`
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          20% { transform: translateX(-8px); }
          40% { transform: translateX(8px); }
          60% { transform: translateX(-6px); }
          80% { transform: translateX(6px); }
        }
        .animate-shake {
          animation: shake 0.4s ease-in-out;
        }
      `}</style>
    </div>
  );
}
